/**
 * Ruta `/simulador/explorar`: cablea el explorador (I-18) con el cliente
 * real del Studio y las migas de vuelta al Simulador. Separado de la vista
 * para que sus tests no carguen ni el cliente ni el router.
 */
import { Link } from "@tanstack/react-router";
import { studio } from "../../api/client";
import { useCrumbs } from "../../shell/crumbSlot";
import { Explorador } from "./Explorador";

export function ExploradorPage() {
  useCrumbs([<Link key="s" to="/simulador">Simulador</Link>, "Explorar"], "explorar");
  return <Explorador api={studio.simulador} />;
}
